var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"header"},[_c('div',{staticStyle:{"margin":"15px"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticStyle:{"height":"120px"},attrs:{"src":"/assets/img/nichs@2x.svg"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }